import type { TutorStructureNode } from '../services/tutorStructureService';

export interface HierarchyPickerOption {
  id: number;
  label: string;
  depth: number;
}

/** Flattens a course structure tree into a depth-ordered list for a parent picker. Includes WRAPPER nodes — any existing node is a valid parent. */
export function flattenStructureForPicker(nodes: TutorStructureNode[]): HierarchyPickerOption[] {
  const options: HierarchyPickerOption[] = [];

  const walk = (list: TutorStructureNode[], depth: number) => {
    for (const node of list) {
      options.push({ id: node.id, label: node.label, depth });
      if (node.children?.length) walk(node.children, depth + 1);
    }
  };

  walk(nodes, 0);
  return options;
}
